import type { RateCard } from "@rebuild/shared/models";

interface ExistingRateCardsTableProps {
  rateCards: RateCard[];
  isLoading: boolean;
  onSelect: (rateCard: RateCard) => void;
}

function formatDate(value: number): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

function ExistingRateCardsTable({ rateCards, isLoading, onSelect }: ExistingRateCardsTableProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="h-6 w-6 animate-spin rounded-full border-b-2 border-blue-600" />
      </div>
    );
  }

  if (rateCards.length === 0) {
    return <p className="text-sm text-gray-500">No rate cards yet for this organization.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Name</th>
            <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Created</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {rateCards.map((card) => (
            <tr key={card.id} onClick={() => onSelect(card)} className="cursor-pointer transition-colors hover:bg-gray-50">
              <td className="px-4 py-2 text-sm font-medium text-blue-600">{card.name}</td>
              <td className="px-4 py-2 text-sm text-gray-600">{formatDate(card.createTime)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ExistingRateCardsTable;
